import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';

const states: Ng1StateDeclaration[] = [
    {
        name: 'scaledPrintPreview',
        url: '/scaledPrintPreview/:guid?beginDate&endDate&groupGuid&printing&lang',
        component: 'wtScaledPrintPreviewState',
        abstract: false,
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve
        },
        params: {
            beginDate: {
                type: 'string'
            },
            endDate: {
                type: 'string'
            },
            groupGuid: {
                value: '',
                squash: true
            },
            lang: {
                value: '',
                squash: true
            },
            printing: {
                value: 'true',
                squash: true
            }
        },
        data: {
            backButtonDisabled: () => false,
            backButtonVisibility: () => true,
            displayName: 'Print preview',
            editButtonDisabled: () => true,
            editButtonVisibility: () => true,
            icon: 'fa-object-group',
            visible: false
        }
    }
];

export default states;
